const IFRAME_RESIZE_ID = 'iframe-resize:id';

const IFRAME_RESIZE_LAYOUT = 'iframe-resize:layout';

export default function setupIframe() {
  const iframes: Record<string, HTMLIFrameElement> = {};
  // @ts-ignore
  window.iframeResizer = (target: unknown) => {
    if (!(target instanceof HTMLIFrameElement)) {
      return;
    }
    const id = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
    target.contentWindow?.postMessage(
      {
        type: IFRAME_RESIZE_ID,
        id,
      },
      '*'
    );
    target.scrolling = 'no';
    iframes[id] = target;
  };
  window.addEventListener('message', (event) => {
    const { id, type, width, height } = event.data || {};
    const target = id ? iframes[id] : Object.values(iframes)[0];
    if (target && type === IFRAME_RESIZE_LAYOUT) {
      if (typeof width !== 'undefined' && target.offsetWidth !== width) {
        target.style.width = `${width}px`;
      }
      if (typeof height !== 'undefined' && target.offsetHeight !== height) {
        target.style.height = `${height}px`;
      }
    }
  });
}
